<!-- Effacer les ligne 1 a 5 après avoir completé
Mettre l'id : ligne 7
Mettre le nom : ligne 59
-->

<template>
    <div id="loadedData">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg" ></s-menuSave> <!--newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" deleteBtn @delete="menuDelete(activeObj.id)"></menuSave>-->

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <div>
                    <!--Affichage de la liste-->
                    <b-row>
                        <s-itemList 
                            v-if="fromApi"
                            style="width: 100%" 
                            :content="fromApi" 
                            :returnValue.sync="activeObj" 
                            showField="dataName" 
                            activeField="isActive" 
                            :selectedItems="activeObj">
                        </s-itemList>
                    </b-row>                            
                </div>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de centre-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="5">
                <!--{{fromApi}}<br><br><br>
                {{activeObj}}<br><br><br>
                {{viewValue}}-->
                <b-row>
                    <!--ACTIF-->
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{activeObj.dataName}}</div>
                            <div class="itemContain">
                                <pre style="font-size: 14px">{{ JSON.stringify(viewValue, null, 4) }}</pre>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                
                <pre>{{ activeObj }}</pre>


            </b-col>
            <!--FIN - Section de centre-->

            <!--Section de droite-->
            <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                
            </b-col>
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';

export default{
    name: "loadedData",
    components: {

    },
    data() {
        return{
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiNomDeLaVariable, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiNomDeLaVariable, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            fromApi: [
                {
                    id: 0,
                    isActive: true,
                    dataName: 'getCompteGL',
                },
                {
                    id: 1,
                    isActive: true,
                    dataName: 'getTaxes',
                },
                {
                    id: 2,
                    isActive: true,
                    dataName: 'getClientContactsOnClient',
                },
                {
                    id: 3,
                    isActive: true,
                    dataName: 'getSupplierContactsOnClient',
                },
                {
                    id: 5,
                    isActive: true,
                    dataName: 'getCombo',
                },
                {
                    id: 6,
                    isActive: true,
                    dataName: 'getCheckSize',
                },
                {
                    id: 7,
                    isActive: true,
                    dataName: 'getLanguage',
                },
                {
                    id: 8,
                    isActive: true,
                    dataName: 'getTaxes',
                },
                {
                    id: 9,
                    isActive: true,
                    dataName: 'getCodeTax',
                },
                {
                    id: 10,
                    isActive: true,
                    dataName: 'getActiveTaxes',
                },
                {
                    id: 11,
                    isActive: true,
                    dataName: 'getAllData',
                },
                
            ], //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            //Objet en cours de modification
            activeObj:{
                id: 0,
                isActive: true,
                dataName: '',
            },
            viewValue: ''

        }
    },
    methods: {
        getMapGetter() {
      
        },
        pushto(link) {
            this.$router.push(link)
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
        },
        menuNew(){
            this.resetAll()
        },
        loadApi() {
            this.sendMsg = '4'
            axios.get(this.apiAddGet1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(response => {
                  this.fromApi = response.data
                  this.sendMsg = ''
                })
                .catch(e => {
                  this.errors.push(e)
                  this.sendMsg = '2'
                })
        },
        menuSave(){
            this.sendMsg = '-'
            let currentObj = this;
            let t = this.activeObj

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                axios.post(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                axios.patch(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });


            }
                setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null
                    let currentObj = this;
                    axios.delete(this.apiAdd1 + '?' + this.apiAddPost1 + '&licence=' + this.$store.getters.getworkLicence + '&id=' + id + '&status=false', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                    .then(function (response) {
                        currentObj.sendMsg = '1'
                        currentObj.output = response.data;
                    })
                    .catch(function (error) {
                        currentObj.sendMsg = '2'
                        currentObj.output = error;
                    });

                    setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress', 'getApiAdd', 'getPageSize', 'getworkLicence', 'getApiKey', 'getCombo', 
                        'getCheckSize', 'getCompteGL', 'getClientAccount', 'getLanguage', 'getTaxes', 'getCodeTax', 'getActiveTaxes','getClientContactsOnClient','getSupplierContactsOnClient']),
        checkAllField() {
            //if (this.activeObj.NomFonction == '')
            //{return true}
            //else
            //{return false}
            return false
        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        //this.loadApi() //charger les licences
        this.InitialState = this.$CObj(this.activeObj)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                //this.loadApi()
            }
        },
        activeObj: function(newValue) {
            this.viewValue = newValue.dataName
            let getters = this.$store.getters
            let currentGetter = Object.entries(getters).filter((getter) => {
                if(getter[0]===newValue.dataName) return getter
            })
            
            this.viewValue = currentGetter[0][1]
            
            /*
            if(this.activeObj.dataName == 'getCompteGL'){this.viewValue = this.getCompteGL}
            else if(this.activeObj.dataName == 'getCombo'){this.viewValue = this.getCombo}
            else if(this.activeObj.dataName == 'getCheckSize'){this.viewValue = this.getCheckSize}
            else if(this.activeObj.dataName == 'getLanguage'){this.viewValue = this.getLanguage}
            else if(this.activeObj.dataName == 'getTaxes'){this.viewValue = this.getTaxes}
            else if(this.activeObj.dataName == 'getCodeTax'){this.viewValue = this.getCodeTax}
            else if(this.activeObj.dataName == 'getActiveTaxes'){this.viewValue = this.getActiveTaxes}
            else if(this.activeObj.dataName == 'getClientAccount'){this.viewValue = this.getClientAccount}
            else{this.viewValue = ''}
            */
            
        },
    }
}
</script>

<style lang="scss" scoped>
.aaa{
    font-size: 15px;
}
</style>